module.exports = __webpack_public_path__ + "./img/btn.657c1712.png";